/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomerConfigClerk } from './CustomerConfigClerk';
import {
    CustomerConfigClerkFromJSON,
    CustomerConfigClerkFromJSONTyped,
    CustomerConfigClerkToJSON,
} from './CustomerConfigClerk';

/**
 * 
 * @export
 * @interface PlayerDataCustomerConfig
 */
export interface PlayerDataCustomerConfig {
    /**
     * 
     * @type {CustomerConfigClerk}
     * @memberof PlayerDataCustomerConfig
     */
    clerk?: CustomerConfigClerk | null;
    /**
     * 
     * @type {string}
     * @memberof PlayerDataCustomerConfig
     */
    firebaseServiceAccountJson?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PlayerDataCustomerConfig
     */
    ticketWalletVisibilityDays?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlayerDataCustomerConfig
     */
    ticketWalletEnabled?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlayerDataCustomerConfig
     */
    allowDeviceTicketScans?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlayerDataCustomerConfig
     */
    claimFormEnabled?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PlayerDataCustomerConfig
     */
    claimsReservationHostUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlayerDataCustomerConfig
     */
    appHostName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlayerDataCustomerConfig
     */
    emailSender?: string | null;
}

/**
 * Check if a given object implements the PlayerDataCustomerConfig interface.
 */
export function instanceOfPlayerDataCustomerConfig(value: object): value is PlayerDataCustomerConfig {
    return true;
}

export function PlayerDataCustomerConfigFromJSON(json: any): PlayerDataCustomerConfig {
    return PlayerDataCustomerConfigFromJSONTyped(json, false);
}

export function PlayerDataCustomerConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayerDataCustomerConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'clerk': json['clerk'] == null ? undefined : CustomerConfigClerkFromJSON(json['clerk']),
        'firebaseServiceAccountJson': json['firebaseServiceAccountJson'] == null ? undefined : json['firebaseServiceAccountJson'],
        'ticketWalletVisibilityDays': json['ticketWalletVisibilityDays'] == null ? undefined : json['ticketWalletVisibilityDays'],
        'ticketWalletEnabled': json['ticketWalletEnabled'] == null ? undefined : json['ticketWalletEnabled'],
        'allowDeviceTicketScans': json['allowDeviceTicketScans'] == null ? undefined : json['allowDeviceTicketScans'],
        'claimFormEnabled': json['claimFormEnabled'] == null ? undefined : json['claimFormEnabled'],
        'claimsReservationHostUrl': json['claimsReservationHostUrl'] == null ? undefined : json['claimsReservationHostUrl'],
        'appHostName': json['appHostName'] == null ? undefined : json['appHostName'],
        'emailSender': json['emailSender'] == null ? undefined : json['emailSender'],
    };
}

export function PlayerDataCustomerConfigToJSON(value?: PlayerDataCustomerConfig | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clerk': CustomerConfigClerkToJSON(value['clerk']),
        'firebaseServiceAccountJson': value['firebaseServiceAccountJson'],
        'ticketWalletVisibilityDays': value['ticketWalletVisibilityDays'],
        'ticketWalletEnabled': value['ticketWalletEnabled'],
        'allowDeviceTicketScans': value['allowDeviceTicketScans'],
        'claimFormEnabled': value['claimFormEnabled'],
        'claimsReservationHostUrl': value['claimsReservationHostUrl'],
        'appHostName': value['appHostName'],
        'emailSender': value['emailSender'],
    };
}

